import Legend from "@arcgis/core/widgets/Legend";
import { Dispatch, forwardRef, SetStateAction, useEffect, useImperativeHandle, useState } from "react";
import "./ClassRailroadVisible.css";
import { ClassIRailroadLegendHandle } from "./ClassRailroadWrapper";

interface iProps {
	view: __esri.MapView;
  classIRailroadLayer: __esri.GroupLayer | undefined;
  setClassIRailroadsVisible: Dispatch<SetStateAction<boolean>>;
}

const ClassRailroadVisible = forwardRef<ClassIRailroadLegendHandle, iProps>(
	({ 
		view,
    classIRailroadLayer,
    setClassIRailroadsVisible
	}, ref) => {

		useImperativeHandle(ref, () => ({
			toggleClassIRailroadsVisible
		}));

	const [legend, setLegend] = useState<Legend>();

	useEffect(() => {
		view.when(() => {
			setLegend(new Legend({
				view: view,
				layerInfos: [{
					layer: view.map.layers
						.find(layer => layer.title === 'Class I Railroads')
				}]
			}));
		});
	}, [view]);

	useEffect(() => {
		if (classIRailroadLayer) {
			setClassIRailroadsVisible(classIRailroadLayer.visible);

			if (classIRailroadLayer.visible) {
				view.ui.add([{
					component: legend,
					position: "bottom-right",
					index: 1
				}]);
			}
		}

		return () => {
			if (legend) view.ui.remove(legend);
		}
	}, [classIRailroadLayer, view, legend, setClassIRailroadsVisible]);

	const toggleClassIRailroadsVisible = () => {
		if (!classIRailroadLayer) return;

		const isVisible = !classIRailroadLayer.visible;
		classIRailroadLayer.visible = isVisible;
		classIRailroadLayer.layers.forEach(layer => { layer.visible = isVisible; });

		setClassIRailroadsVisible(isVisible);
		if (isVisible && !view.ui.find(legend!.id)) {
			view.ui.add([{
				component: legend,
				position: "bottom-right",
				index: 1
			}]);
		} else if (view.ui.find(legend!.id)) {
			view.ui.remove(legend!);
		}
	}

	return null;
});

export default ClassRailroadVisible;